module.exports = __webpack_public_path__ + "img/right-arrow.7a2bf8d9.svg";